var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',_vm._g(_vm._b({staticClass:"bg-primary text-white font-semibold tracking-widest rounded px-4 py-2 uppercase disabled:bg-primary/50",attrs:{"text":_vm.text}},'base-button',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }